import { createSelector } from 'reselect'
import { createGetter, composeGetters } from 'react-redux-getters'
import { getCollection, replaceCollections } from '@fakundo/redux-entities'
import { MINDBODY_CLASSES } from 'constants/entityNames'
import { classesListMindbody } from 'actions/integrations'
import size from 'lodash/size'
import some from 'lodash/some'
import orderBy from 'lodash/orderBy'
import filter from 'lodash/filter'
import groupBy from 'lodash/groupBy'
import moment from 'moment'
import { getMe } from 'selectors/me'

import {
  MAILCHIMP,
  WORKFLOWMAX,
  SLACK,
  MINDBODY,
} from 'constants/integrations'

export const isMailChimpConnected = createSelector(
  getMe,
  meGetter => composeGetters(
    meGetter,
    meGetterData => some(meGetterData.integrations, { serviceName: MAILCHIMP })
  )
)

export const isWorkflowMaxConnected = createSelector(
  getMe,
  meGetter => composeGetters(
    meGetter,
    meGetterData => some(meGetterData.integrations, { serviceName: WORKFLOWMAX })
  )
)

export const isMindbodyConnected = createSelector(
  getMe,
  meGetter => composeGetters(
    meGetter,
    meGetterData => some(meGetterData.integrations, { serviceName: MINDBODY })
  )
)

export const isSlackConnected = createSelector(
  getMe,
  meGetter => composeGetters(
    meGetter,
    meGetterData => some(meGetterData.integrations, { serviceName: SLACK })
  )
)

export const isStripeConnected = createSelector(
  getMe,
  meGetter => composeGetters(
    meGetter,
    meGetterData => !!meGetterData.business.connectedAccountId
  )
)

export const isCalendarConnected = createSelector(
  getMe,
  meGetter => composeGetters(
    meGetter,
    meGetterData => !!size(meGetterData.calendars)
  )
)

export const isZapierConnected = createSelector(
  getMe,
  meGetter => composeGetters(
    meGetter,
    meGetterData => !!meGetterData.hooks
  )
)

export const getMindbodyClasses = createGetter({
  stateSelector: state => getCollection(state, MINDBODY_CLASSES),
  asyncFetcher: dispatch => dispatch(classesListMindbody()),
  stateUpdater: (mindbodyClasses, dispatch) => dispatch(replaceCollections({
    [MINDBODY_CLASSES]: mindbodyClasses
  })),
})

export const getMindbodyClassGroups = createSelector(
  getMindbodyClasses,
  mindbodyClassesGetter => composeGetters(
    mindbodyClassesGetter,
    (mindbodyClasses) => {
      const orderedClasses = orderBy(mindbodyClasses, 'StartDateTime')
      const filteredClasses = filter(orderedClasses, { Active: true, IsAvailable: true })
      return groupBy(filteredClasses, clas => (
        moment(clas.StartDateTime).format('dd-MM-YYYY')
      ))
    }
  )
)
